import { abtastyService } from "@/services";
import { useDispatch } from 'react-redux';
import { useAppDispatch } from '@/store';
import { formatCurrency } from '../../../utils/formatters.util';
import Checkbox from '../Checkbox';
import DiscountRibbon from '../DiscountRibbon';
import { addUpsellItem, removeUpsellItem } from '../../../actions/pdp.actions';
import classNames from 'classnames';
import { memo } from 'react';
import Badge from '../Badge';
import WebImage from '@components/tailwind/WebImage';

const Item = ({ item, isSelected = false }) => {
  const dispatch = useAppDispatch();
  const image = item?.item?.webImages.default.thumb;

  const onItemClick = () => {
    if (!item.itemId) return;

    if (isSelected) {
      dispatch(removeUpsellItem(item.itemId));
      abtastyService.trackClick('Accessory Upsell: Remove');
    } else {
      dispatch(addUpsellItem(item));
      abtastyService.trackClick('Accessory Upsell: Add');
    }
  };

  return (
    <div
      className='tw-relative tw-flex tw-cursor-pointer tw-items-center tw-gap-5 tw-border-b tw-border-gray-300 tw-py-3 last:tw-border-b-0'
      onClick={onItemClick}>
      <Badge size='sm' className='tw-absolute tw-right-0 tw-top-4'>
        {Math.round(item?.percentOff)}% OFF
      </Badge>
      <Checkbox
        name={`upsell-check-${item?.itemId}`}
        id={`upsell-check-${item?.itemId}`}
        checked={isSelected}
        setChecked={(val) => {}}
        size='lg'
        variant='outlined'
        value={item.itemId}
      />
      <div className='tw-flex tw-items-center tw-gap-3 tw-pr-[70px] md:tw-gap-4'>
        {image && (
          <div className='tw-flex tw-w-[60px] tw-items-center tw-justify-center md:tw-w-[80px]'>
            <WebImage
              webImage={image}
              alt={item.displayName}
              className='tw-max-h-full tw-w-full tw-max-w-full'
            />
          </div>
        )}
        <div className='tw-w-[calc(100%-72px)] md:tw-w-[calc(100%-96px)]'>
          <p className='tw-mb-0 tw-text-sm tw-font-bold tw-leading-4 hover:tw-text-body hover:!tw-no-underline md:tw-mb-1 md:tw-text-sm md:tw-leading-5'>
            {item.title}
          </p>
          <p
            className={classNames('tw-mb-0 tw-text-sm tw-font-medium md:tw-mt-1 md:tw-text-sm', {
              'tw-text-red-700': !!item?.percentOff && item.percentOff > 0,
            })}>
            +{formatCurrency(item?.rate ?? item?.itemRate)}
          </p>
          {/* {!!item?.percentOff && item.percentOff > 0 && (
            <p className='tw-mb-0 tw-text-sm tw-font-normal tw-text-gray-600 tw-line-through'>
              {formatCurrency(item.itemRate)}
            </p>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default memo(Item);
